import {request} from "../../request/request";

const client = {
  getAccept: (params) => request.read('/oauth/client/accept', params, true),
  getAccepted: (params) => request.read('/oauth/client/accepted', params, true),
  getOne: (clientId) => request.read(`/oauth/client/${clientId}`, null, true),
};

export {client};